import React from 'react';
import { Map } from 'immutable';
import atomicBlock from '../../atomicBlock';
import Media from './Block';

const MediaBlock = atomicBlock({ feature: true })(Media);
const StaticMediaBlock = atomicBlock({
  feature: true,
  deletable: false,
  alignment: false,
})(Media);

const createPlugin = (isDownloadable = true) => {
  return {
    blockRendererFn: (block, { getProps }) => {
      const type = block.getType();
      const props = getProps();
      const { pageType } = props;
      if (
        type === 'media' ||
        (pageType === 'event' && type === 'static-media')
      ) {
        return {
          component: MediaBlock,
          editable: false,
        };
      }
      if (type === 'static-media') {
        return {
          component: StaticMediaBlock,
          editable: false,
        };
      }
      return null;
    },
    blockRenderMap: Map({
      media: {
        element: 'figure',
        editable: false,
        caption: true,
        isBlockTypeMutable: false,
      },
      'static-media': {
        element: 'figure',
        editable: false,
        caption: true,
        isBlockTypeMutable: false,
      },
    }),
  };
};

export default createPlugin;
